import { render, staticRenderFns } from "./submitResult.vue?vue&type=template&id=100ad06e&scoped=true&"
import script from "./submitResult.vue?vue&type=script&lang=js&"
export * from "./submitResult.vue?vue&type=script&lang=js&"
import style0 from "./submitResult.vue?vue&type=style&index=0&id=100ad06e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100ad06e",
  null
  
)

export default component.exports